import React from "react";
import headerBackgroundImage from "./card-background-2.png";

function Ideology() {
  return (
    // <div className='' style={{ backgroundImage: `url(${headerBackgroundImage})` }}>
    <div className="py-8">
      {/* <div>
                <img className='w-full' src='newimage/banner/aboutBrother.svg'></img>
            </div> */}
      <div>
      <h2 className="border-b-2 border-[gainsboro] w-[20%] mx-auto items-center flex-col justify-center font-serif text-center text-blue-800 text-[26px] rounded-2xl">
      OUR IDEOLOGY
      </h2>
        {/* <div className="p-2 mx-[28%] items-center flex-col justify-center font-serif text-center text-blue-800 text-2xl bg-[aliceblue] rounded-full">
          <div className="h-[2px] my-auto mx-2 w-20 bg-blue-800 inline-block"></div>
          OUR IDEOLOGY
          <div className="h-[2px] my-auto w-20 bg-blue-800 inline-block mx-2"></div>
        </div> */}
        <h4 className="text-center font-serif text-[16px] lg:w-[1000px] mx-auto pt-3">
          Ideology is the fundamental idea that forms the bedrock of thoughts,
          words and actions of the individuals of a community. The idea of being
          a nirankari is very simple, yet profound.
        </h4>

        <div className="grid gap-6 px-10 pt-10 pb-20 xs:grid-cols-1 md:grid-cols-2">
          <div className="col-span-1 ">
            <img
              src="image/home/lagacy-3.jpg"
              className=" w-[100%]  mx-auto rounded-2xl"
            ></img>
          </div>
          <div className="col-span-1">
            {/* <h1 className="pb-1 font-medium xs:text-xl md:text-xl xs:pt-4">
              {" "}
              Our Ideology
            </h1> */}
            {/* <div className="border-b-2 border-blue-800 w-36"></div> */}
            <p className="font-serif text-justify overflow-y-scroll h-[330px] text-[18px]">
              Ideology is the fundamental idea that forms the bedrock of
              thoughts, words and actions of the individuals of a community. The
              idea of being a nirankari is very simple, yet profound. A
              nirankari is a ‘Sant’, trying to lead a simple saintly life at all
              times, in all places and among all relationships. Here, saintly
              does not mean dressing up in a specific way, rather embellishing
              our deeds with truth, love, tolerance, compassion and selfless
              service. A nirankari is guided towards selfless service by the
              mission’s first doctrine of Sewa, which does not mean helping or
              doing a favour; rather meeting out our responsibility being a
              human to serve others without seeking anything in return; it is
              indeed a blessing of god to have given us the intent, strength and
              intelligence to be able to serve others. We thus, thank the one
              who gives us an opportunity to serve. The mission and its devotees
              have been reaching out to the society through numerous such
              efforts and initiatives like blood donation camps, mass marriages,
              value-based centers of education, relief and rehabilitation of our
              brothers and sisters during natural calamities, tree plantation,
              cleanliness and social awareness drives etc. Even during the
              current Covid-19 crisis, the Mission contributed in numerous ways,
              all of which has been detailed in the Community Service section of
              the website. We are ‘Nirankari’, which means we have been endowed
              with the spiritual truth and awareness of the eternal, formless,
              all-pervading almighty God by the grace of our Satguru; and with
              this one God, who may be addressed as Allah, Ishwar, Vitthal or
              Nirankar, our relationship is that of mindful remembrance. This
              one Nirankar becomes the source of our strength in times of
              weakness, our foundation of peace in times of turmoil, our
              fragrance of love in times of hatred and our key to moderation in
              times of ego and attachment. Our connect to Nirankar is effortless
              and smooth. All one has to do is recite the three lines of Simran
              and be aware of the Gyan (God-Realization) as bestowed by the
              Satguru. Here are the three magical lines that lead a soul to the
              sphere of nothingness: “Tu Hi Nirankar” (Only YOU are the Formless
              Almighty God) “Main Teri Sharan Haan” (I completely surrender unto
              YOU) “Mainu Baksh Lo” (Forgive all my sins) We are an
              all-embracing socio-spiritual dynamic and practical Mission,
              rather a movement dedicated to establish and maintain love, peace,
              equality, oneness and a world without walls, without any prejudice
              or discrimination. We strive to achieve this, first in our own
              lives and then in the lives of other brothers and sisters of the
              common humankind. This, we understand is possible only once we
              realize our true self by knowing god in the true and absolute
              manifestation through a living master, called Satguru (The
              dispeller of all darkness and the benefactor of eternal light). It
              becomes even more uncomplicated and manifest to experience, share
              and elevate the blissful state of mind, when we get to connect
              with other enlightened souls at the regularly organised Satsangs
              (Congregations) and Samagams (Large gatherings of devotees).
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Ideology;
